import { useMemo } from 'react';
import { calcMultiplier } from '../utils/racing-game/helpers.ts';
import { useCurrencyStore } from '../services/store';
import { useGameResultStore } from '../services/store/racing-game';

export const usePreviousGameRoundWebsocketResults = (enabled?: boolean) => {
  const currencyId = useCurrencyStore(({ currency }) => currency.id);
  const raceResultsRound = useGameResultStore(({ data }) => data?.round);
  const raceResults = useGameResultStore(({ data }) => data?.results);
  const raceMultipliers = useGameResultStore(({ data }) => data?.mul);

  /*
   * Because new currency id 100 has been added
   * this trick is required. Should be properly mapped in the future
   * */
  const multiplierId = currencyId !== 100 ? currencyId : 1;
  const top3 = useMemo(() => {
    if (enabled === false || !raceResults) return [];

    const { first, second, third } = raceResults.top3;

    return [first, second, third].map(({ token }, index) => {
      const multiplier = (() => {
        const currencyData = raceMultipliers?.[multiplierId];
        if (!currencyData) return null;

        const mult = currencyData.a[token];
        const sum = currencyData.sumA;

        return (
          calcMultiplier(sum, mult, {
            multiplierRatioPlace: index,
          }) || null
        );
      })();

      return {
        token,
        multiplier,
      };
    });
  }, [enabled, multiplierId, raceResults, raceMultipliers]);

  const winnerGroup = useMemo(() => {
    if (enabled === false || !raceResults?.winnerGroup) return null;

    const multiplier = (() => {
      const currencyData = raceMultipliers?.[multiplierId];
      if (!currencyData) return null;

      const mult = currencyData.b[raceResults.winnerGroup];
      const sum = currencyData.sumB;

      return calcMultiplier(sum, mult, { multiplierRatioPlace: null }) || null;
    })();

    return {
      groupName: raceResults.winnerGroup,
      multiplier,
    };
  }, [enabled, multiplierId, raceResults, raceMultipliers]);

  return useMemo(
    () => ({
      round: raceResultsRound,
      top3,
      winnerGroup,
    }),
    [raceResultsRound, top3, winnerGroup]
  );
};
